import { some } from 'lodash'
import $ from 'jquery'

export function isSectionFilled(section) {
  // returns true if section has at least one answer filled
  const rawAnswers = section.items.map((i) => i.answer)
  const parsedAnswers = rawAnswers.map((answer) => $.parseHTML(answer || ''))
  const answers = parsedAnswers.map((answer) => $.text(answer))
  return some(answers)
}
